import { observer } from 'mobx-react-lite'
import { Alert, Divider, Icon, Typography } from 'shared/ui'
import { type Phone } from 'entities/Phone/model/Phone'
import { type Cnam } from 'entities/Compliance/model/OrganizationCnam/Cnam'
import { ModalHeader } from 'pages/settings/pages/compliance/ui/ModalHeader/ModalHeader'
import { type SummaryStore } from 'pages/settings/pages/compliance/pages/calling/store/SummaryStore'
import { EstimatedResponseInfo } from 'pages/settings/pages/compliance/ui/EstimatedResponseInfo/EstimatedResponseInfo'
import { statusMap } from 'pages/settings/pages/compliance/pages/calling/constants'
import styles from './styles.module.scss'

type IBrandModalContentProps = {
  store: SummaryStore
  cnam: Cnam
}

const PhoneItem = ({ phone }: { phone: Phone }) => {
  return (
    <div className={styles.phoneItem}>
      <Typography ariaLabel='formattedNumber' variant='body-md-regular'>
        {phone.formatted_number}
      </Typography>
      {phone.is_aircall && <Icon icon='aircall' className={styles.aircallIcon} />}
      <div className={styles.dot} />
      <Typography
        ariaLabel='inboxName'
        variant='text-input-field-r'
        color={'var(--content-primary-tertiary)'}
      >
        {phone.numberableName || 'Unassigned'}
      </Typography>
    </div>
  )
}

export const CnamCallerIdModalContent = observer(({ store, cnam }: IBrandModalContentProps) => {
  const { cnamNumbers } = store

  const statusData = cnam.status && <EstimatedResponseInfo iconData={statusMap[cnam.status]} />

  const errorMessage = cnam.registrationError?.message

  return (
    <>
      <ModalHeader header={cnam.name || ''} statusData={statusData} />

      {errorMessage && (
        <Alert
          item={{
            type: 'error',
            desc: errorMessage,
          }}
          marginBottom={32}
          actions={[
            {
              variant: 'button',
              type: 'primary',
              text: 'Update',
              onClick: () => store.openCnamToUpdate(cnam),
            },
            {
              variant: 'button',
              type: 'secondary',
              text: 'Learn more',
              onClick: store.learnMoreModalAction,
            },
          ]}
        />
      )}

      {!errorMessage && <Divider sx={{ borderColor: 'var(--black-20)', marginBottom: '40px' }} />}

      <Typography variant='body-rg-medium' ariaLabel='phoneTitle' marginBottom={16}>
        {`Phone numbers (${cnamNumbers.length})`}
      </Typography>
      <div className={styles.phoneList}>
        {cnamNumbers.map((phone) => (
          <PhoneItem key={phone.id} phone={phone} />
        ))}
      </div>
    </>
  )
})
